export default __webpack_public_path__ + "static/media/Screenshot_1.7c29ebc0.png";